import { createContext } from 'react';

import { User } from '@/data/models/user.interface';

export interface AuthContextType {
  user: User;
  isAuthenticated: boolean;
  isLoading: boolean;
  authError: { message: string; status: number; timestamp: number } | null;
  logout: () => void;
  login: () => void;
  checkPermission: (_permission: string) => boolean;
  refetch: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);
